var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Spiner",staticStyle:{}},[_c('v-overlay',{attrs:{"value":_vm.dialog}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":100,"width":7,"color":"#efce6a"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }